import SlideshowIcon from '@mui/icons-material/Slideshow';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Radio, RadioChangeEvent } from 'antd';
import { ROUTES } from 'base/routes/routes';
import CustomSelect from 'base/ui/components/CustomSelect';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AiOutlineMinus } from 'react-icons/ai';
import { FaSearch } from 'react-icons/fa';
import { TbLoaderQuarter } from 'react-icons/tb';
import { Link, useNavigate } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { EquipmentStatusSearch, ListKeynValue } from 'services/report_services';
import * as rootStore from 'stores/root_store';
import { StatusColorTable } from '../BC01machineStatus/machineStatus';

const Style = {
  '.MuiOutlinedInput-root': {
    padding: 0,
    borderRadius: 0,
  },
  '.css-13xfq8m-MuiTabPanel-root': {
    padding: '5px !important',
  },
  '.css-tqw3aj .css-13xfq8m-MuiTabPanel-root': {
    padding: 5,
  },
  '.MuiOutlinedInput-input': {
    fontSize: '11px',
  },
  '.MuiInputBase-input': {
    fontSize: '13px !important',
  },
  '.MuiOutlinedInput-notchedOutline': { borderRadius: 0 },
  '.MuiChip-labelMedium': {
    fontSize: '11px',
    padding: '3px',
    fontWeight: '600',
  },
  '.css-ahj2mt-MuiTypography-root': {
    fontSize: '11px !important',
    fontWeight: '600 !important',
  },
  '.css-9l3uo3': {
    fontSize: '11px !important',
    fontWeight: '600 !important',
  },
};

export const StatusColor = {
  CM: 'Canh máy',
  HD: 'Hoạt động',
  VS: 'Vệ sinh',
  NM: 'Ngưng máy',
  ET: 'Trống',
};

type SearchModel = Partial<{
  groupEq: string[];
  statusKey: string | null;
  wSId: string | null;
  listENS: string[];
  actived: boolean;

  machineStatus: string
}>;

export function createProductionPlan() {
  return observer(() => {
    //loading page when reload
    const [isLoading, setIsLoading] = useState(false);
    //cac row trong so do
    const diagramRows = rootStore.reportStore.WorkShopEquipmentsStatus.data;
    //searchbox dong mo
    const [openSearchBox, setOpenSearchBox] = useState(false);
    // Form validation-----------------------------------
    const { register, handleSubmit } = useForm<EquipmentStatusSearch>();
    const navigate = useNavigate();

    // data Search --------------------------------------------------------------------------------------
    const [dataSearch, setDataSearch] = useState<SearchModel | undefined>({
      groupEq: [],
      statusKey: '',
      wSId: '',
      listENS: [],
      actived: true,
      machineStatus: ''
    });
    // list workshop danh sách phân xưởng
    const [listWS, setListWS] = useState<ListKeynValue[]>([]);
    // list status danh sách trạng thái
    const [listStatus, setListStatus] = useState<ListKeynValue[]>([]);
    // list status danh sách trạng thái
    const [listGE, setListGE] = useState<ListKeynValue[]>([]);
    // danh sách tên máy
    const [listEN, setListEN] = useState<ListKeynValue[]>([]);

    // =================================================================================================
    // FOR SEARCH : CẬP NHẬT THAY ĐỔI CHO CÁC DROP DOWN
    const handleChangeSelect = async (value: any, option: ListKeynValue, idKey: string) => {
      if (option && !Array.isArray(option)) {
        setDataSearch({ ...dataSearch, [idKey]: option.key });
        await getListNhomMay([option.key]);
        getListEN(option.key);
      } else {
        setDataSearch({ ...dataSearch, [idKey]: '' });
        await getListNhomMay();
        getListEN('');
      }
    };
    const handleChangeSelectMul = async (value: any, option: ListKeynValue, idKey: string) => {
      if (option && Array.isArray(option)) {
        setDataSearch({ ...dataSearch, [idKey]: option.map((i) => i.key) });
      } else {
        setDataSearch({ ...dataSearch, [idKey]: undefined });
      }
    };

    // FOR SEARCH : HÀM THỰC HIỆN QUÁ TRÌNH TÌM KIẾM
    const onSearch = async () => {
      setIsLoading(true);
      //equipmentList: listENS,
      await rootStore.reportPresenter.WorkShopEquipments(
        rootStore.reportStore,
        dataSearch?.wSId || null,
        dataSearch?.groupEq,
        dataSearch?.machineStatus || null,
        dataSearch?.listENS,
        dataSearch?.actived,
      );
      setIsLoading(false);
    };

    const handleCheckBox = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
      if (e.target.checked) {
        rootStore.reportPresenter.setItemId(rootStore.reportStore, [...rootStore.reportStore.stateItemId, id]);
      } else {
        rootStore.reportPresenter.setItemId(
          rootStore.reportStore,
          rootStore.reportStore.stateItemId.filter((item) => item !== id),
        );
      }
    };

    const getListNhomMay = async (phanXuong?: string[]) => {
      await rootStore.reportPresenter.getListGroupEquip(rootStore.reportStore, phanXuong ? phanXuong : []);
      //that should be slow
      setListGE(
        Array.from(
          rootStore.reportStore.listKeynValue.data.filter(
            (value, index, self) => self.map((x) => x.value).indexOf(value.value) == index,
          ),
        ),
      );
    };

    const getListEN = async (key: string) => {
      await rootStore.reportPresenter.getListDropdownEquipmentName(rootStore.reportStore, key);
      setListEN(rootStore.reportStore.listKeynValue.data);
    };

    // HÀM CHẠY LAN DAU
    useEffect(() => {
      setIsLoading(true);
      rootStore.reportPresenter.setItemId(rootStore.reportStore, dataSearch?.wSId ? [dataSearch.wSId] : []);

      const getListWSName = async () => {
        await rootStore.reportPresenter.getListWorkShop(rootStore.reportStore);
        setListWS(rootStore.reportStore.listKeynValue.data);
      };
      getListWSName();

      const getListEquipStatus = async () => {
        await rootStore.reportPresenter.getListEquipmentStatus(rootStore.reportStore);
        setListStatus(rootStore.reportStore.listKeynValue.data);
      };

      getListEquipStatus();

      getListNhomMay();

      getListEN('');
      // list toàn bộ thông tin của các máy móc và tầng
      const getWSE = async () => {
        await rootStore.reportPresenter.WorkShopEquipments(rootStore.reportStore, null, [], null, [], true);
        setIsLoading(false);
      };
      getWSE();
    }, []);

    // hàm handle change value của tình trạng sử dụng trong search
    const onChangeStatus = (e: RadioChangeEvent) => {
      setDataSearch({ ...dataSearch, actived: e.target.value });
    };

    //===============================================================
    //=========================== RETURN ZONE =======================
    //===============================================================
    const date = new Date().toLocaleDateString('en-GB');
    return (
      <div className="w-full py-3 px-5">
        <div
          className={`fixed text-white text-default z-30 top-[82px] right-16 align-middle
                    bg-primary cursor-pointer rounded-[5px] hover:bg-primary/80`}
        >
          <Link to={ROUTES.REPORTS.REPORT_KHSX.DETAILS_LINK}>
            <div className="px-5 py-[6px]">
              <SlideshowIcon data-tip data-for="buttonTip" />
              <span className="pl-1">Xem</span>
            </div>
            <ReactTooltip id="buttonTip" place="top" effect="float">
              Xem báo cáo chi tiết
            </ReactTooltip>
          </Link>
        </div>
        <div className="title text-center">
          {isLoading && <LoadingScreen />}
          <h3 className="text-md font-bold text-gray-800 mb-2 uppercase">
            BC02. KẾ HOẠCH SẢN XUẤT THEO MÁY MÓC / CHUYỀN SẢN XUẤT
          </h3>
          <span className="italic text-xs underline">Ngày : {date}</span>
        </div>

        {/* Form nhập tìm kiếm */}
        <div className={`relative ${openSearchBox ? 'border' : ''} mb-2 rounded`}>
          <div
            onClick={() => setOpenSearchBox(!openSearchBox)}
            className="absolute bg-primary w-9 h-9 rounded-[5px]
            flex justify-center items-center top-[-36px] right-0 hover:bg-primary/80"
          >
            <AiOutlineMinus className={`text-white ${openSearchBox ? 'block' : 'hidden'} duration-700 text-default`} />
            <FaSearch className={`text-white ${openSearchBox ? 'hidden' : 'block'}  duration-700 text-default`} />
          </div>
          <div
            className={`w-full bg-white flex overflow-hidden ${openSearchBox ? 'opacity-100' : ' opacity-0 h-0'
              } duration-700`}
          >
            <form onSubmit={handleSubmit(onSearch)} className="w-full p-3.5 lg:grid lg:grid-cols-2 flex flex-col gap-2">
              {/* Chọn phân xưởng */}
              <div className="w-full sm:items-center grid grid-cols-3">
                <CustomSelect
                  title="Phân xưởng"
                  data={listWS}
                  idKey="wSId"
                  placeholder="--Tất cả--"
                  allowClear
                  onChangeValue={handleChangeSelect}
                />
              </div>
              {/* Chọn trạng thái */}
              <div className="w-full sm:items-center grid grid-cols-3">
                <CustomSelect
                  title="Trạng thái"
                  data={listStatus}
                  idKey="machineStatus"
                  allowClear
                  placeholder="--Tất cả--"
                  onChangeValue={(value: any, option: any, idKey: string) => {
                    if (option && !Array.isArray(option)) {
                      setDataSearch({ ...dataSearch, machineStatus: option.key });
                    } else {
                      setDataSearch({ ...dataSearch, machineStatus: '' });
                    }
                    // handleChangeSelect(value, option, idKey)
                  }}
                />
              </div>
              {/* Chọn Nhóm máy */}
              <div className="w-full sm:items-center grid grid-cols-3">
                <CustomSelect
                  title="Nhóm máy"
                  data={listGE}
                  idKey="groupEq"
                  allowClear
                  showSearch
                  placeholder="Chọn tổ..."
                  onChangeValue={handleChangeSelectMul}
                  mode="multiple"
                />
              </div>
              {/* Chọn tên máy */}
              <div className="w-full sm:items-center grid grid-cols-3">
                <CustomSelect
                  title="Tên máy"
                  data={listEN}
                  idKey="listENS"
                  allowClear
                  showSearch
                  placeholder="Chọn tên máy..."
                  onChangeValue={handleChangeSelectMul}
                  mode="multiple"
                />
              </div>

              {/* Tình trạng sử dụng */}
              <div className="w-full sm:items-center grid grid-cols-3">
                <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">
                  Tình trạng sử dụng
                </label>
                <Radio.Group className="col-span-2 !ml-5" onChange={onChangeStatus} value={dataSearch?.actived}>
                  <Radio value={true}>Đang sử dụng</Radio>
                  <Radio value={false}>Ngưng sử dụng</Radio>
                </Radio.Group>
              </div>

              {/* button tìm kiếm */}
              <div className="w-full flex justify-center col-span-2">
                <button
                  type="submit"
                  onClick={handleSubmit(onSearch)}
                  className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 mt-1 text-center focus:outline-none hover:bg-blue-600 ${isLoading && 'bg-blue-400'
                    }`}
                >
                  {isLoading ? (
                    <>
                      <TbLoaderQuarter className="animate-spin bg" />
                      Loading...
                    </>
                  ) : (
                    <>
                      <FaSearch className="font-bold" />
                      &nbsp; Tìm kiếm
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* bảng chú thích */}
        <table
          width={300}
          className="h-fit bg-white text-default table-auto space-collapse"
        >
          <thead className="text-white !bg-[#1677ff]">
            <tr>
              <th
                className="font-semibold border border-border_input"
              >
                Màu sắc
              </th>
              <th
                className="font-semibold border border-border_input"
              >
                Trạng thái máy
              </th>
            </tr>
          </thead>
          <tbody>
            {StatusColorTable.map((item) => {
              return (
                <tr key={item.name}>
                  <td
                    className={`px-2 border border-border_input ${item.value}`}
                    width={100}
                  >
                  </td>
                  <td
                    className={"border border-border_input px-2"}
                  >
                    {item.name}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div>
          {diagramRows?.length ? (
            diagramRows?.map((item, index) => {
              return (
                <div key={index} className={`w-full mt-5 ${index} mb-5 bg-white/80 py-3 px-2 rounded-sm`}>
                  <div className="p-3 border-b-2 border-black text-white bg-[#4682B4]">
                    <h2 className="text-default font-bold ">{item.workShopName}</h2>
                  </div>
                  {/* ======================================================================== */}
                  <div className="grid grid-cols-2` sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7 coverDiagram">
                    {item.workShopEquipments.map((it, id) => {
                      return (
                        <div
                          id={it.id}
                          key={it.id}
                          className={`
                          ${it.status === StatusColor.HD ? 'bg-green-500' : ''}
                          ${it.status === StatusColor.CM ? 'bg-[#FEF5AC]' : ''}
                          ${it.status === StatusColor.VS ? 'bg-[#C1EFFF]' : ''}
                          ${it.status === StatusColor.NM ? 'bg-[#FFB3B3]' : ''}
                          ${it.status === StatusColor.ET ? 'bg-white' : ''}
                          col-span-1 p-1 m-2 text-default font-semibold insideDiagram
                          shadow-md shadow-gray-400 rounded-sm`}
                        >
                          <div className="text-xs">
                            <FormControlLabel
                              sx={Style}
                              control={<Checkbox onChange={(event) => handleCheckBox(event, it.id)} />}
                              label={it.equipmentName}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })
          ) : (
            <div>
              <div className="border whitespace-nowrap p-1.5 text-default text-center">
                Không tìm thấy nội dung phù hợp
              </div>
            </div>
          )}
        </div>
      </div>
    );
  });
}
